import { useCallback, useEffect, useState } from "react";
import { FilterState, OfficeListData } from "../types";
import { INITIAL_STATUSES } from "../constants";
import { propertyDayOfficeListService } from "../../../../../services/PropertyServices";
import { toastError } from "../../../../../../../components/Toast";

export const useOfficeFilter = (propertyId: string, companyId: string) => {
  const [filter, setFilter] = useState<FilterState>({
    page: 1,
    keyword: "",
    order_by: "",
    sort_by: "",
    statuses: INITIAL_STATUSES,
    property_id: propertyId,
    code: "",
    company_id: companyId,
  });

  const updateFilter = useCallback((updates: Partial<FilterState>) => {
    setFilter((prevState) => ({ ...prevState, ...updates }));
  }, []);

  return { filter, updateFilter };
};

export const useOfficeData = (filter: FilterState, refreshTrigger: boolean) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<OfficeListData>({
    day_offices: [],
    pagination: { total: 0 },
  });

  useEffect(() => {
    let isCancelled = false;

    (async () => {
      try {
        setLoading(true);
        const response = await propertyDayOfficeListService(filter);

        if (!isCancelled) {
          setData(response.data);
        }
      } catch (error) {
        if (!isCancelled) {
          console.error("Failed to fetch office data:", error);
          toastError("Unable to fetch office data");
        }
      } finally {
        if (!isCancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      isCancelled = true;
    };
  }, [filter, refreshTrigger]);

  return { data, loading };
};
